/** True for Safari / WebKit on iPhone, iPod, iPad (including iPadOS desktop UA). SSR-safe: false without window. */
export function isIosDevice(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  const ua = window.navigator.userAgent;
  if (/iPad|iPhone|iPod/i.test(ua)) {
    return true;
  }

  const { navigator: nav } = window;
  // iPadOS 13+ may report MacIntel + touch
  return (
    nav.platform === "MacIntel" &&
    typeof nav.maxTouchPoints === "number" &&
    nav.maxTouchPoints > 1
  );
}
